import { IconTip } from '@st/theme'
import { RadioSelectConfig } from '@st/ui-config'
import { ConfigInputProps } from '@util/input-component'
import { clsx } from 'clsx'
import { ChangeEvent, useId } from 'react'

type Props = ConfigInputProps<RadioSelectConfig, string | undefined>
export function RadioSelect({ value, options, onChange, label }: Props) {
  const name = useId()

  const optionsComponents = options.map((opt) => {
    return (
      <RadioSelectOption
        {...opt}
        key={opt.key}
        name={name}
        selected={opt.key == value}
        onSelect={() => onChange(opt.key)}
      />
    )
  })

  return (
    <div
      role="radiogroup"
      aria-label={label ?? undefined}
      className="flex w-full flex-col items-stretch gap-5 p-0.5"
      style={{ padding: 2 }}
    >
      {optionsComponents}
    </div>
  )
}

type RadioSelectOptionProps = {
  label?: string
  name: string
  tip?: { title?: string; body?: string } | null
  onSelect: () => void
  selected?: boolean
}
export function RadioSelectOption({
  label,
  name,
  tip,
  selected,
  onSelect
}: RadioSelectOptionProps) {
  const id = useId()

  function onChange(e: ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      onSelect()
    }
  }

  return (
    <div
      className={clsx(
        'h-16 cursor-pointer rounded-lg px-5 font-bold outline outline-1 outline-gray-200',
        'flex flex-row items-center',
        {
          'bg-gradient-to-tr from-[#526bf0] to-[#8572ff] text-white outline-none hover:outline-none':
            selected,
          'hover:outline-2 hover:outline-blue-500': !selected
        }
      )}
      onClick={() => onSelect()}
    >
      <input type="radio" name={name} checked={selected} id={id} onChange={onChange} />
      <label className="ml-2 cursor-pointer text-lg font-bold" htmlFor={id}>
        <span>{label}</span>
        {tip ? <span>&nbsp;</span> : null}
        {tip && (
          <IconTip
            title={tip.title}
            body={tip.body}
            className={selected ? 'text-white' : 'text-blue-500'}
          />
        )}
      </label>
    </div>
  )
}
